import { getLanguageContent } from "../../../../../utils/language/languageSelector";
import { INSIGHTS_HUB_SCHEMA } from "../../../../../utils/schemas/language/pages/insightsHubSchema";

const content = getLanguageContent(INSIGHTS_HUB_SCHEMA);

export const freePlanFeatures = content.plans.free.features;
export const basicPlanFeatures = content.plans.paid.features;
